// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__PA4di","rotation":"Loader_rotation__V5zBv"};